
import {Options, Vue} from "vue-property-decorator";

@Options({
  components: {}
})
export default class FormPartBConfirmation extends Vue {

}

